import { environment } from '@environment';
import { ApiModels } from '@mona/api';
import { Patient } from '@mona/models';

export const customFrequencyCode = environment.customFrequencyCode;
export const noRequiredFrequencyCode = environment.noRequiredFrequencyCode;

export const MOCK_MEDICATION_CATEGORIES = [
    {
        id: 'INJECTIONS',
        code: 'INJECTIONS',
        displayName: 'Injektionen',
        fieldConfig: {
            amount: {
                required_display: true,
                required_create: true,
                required_update: false,
                required_administration: true,
                required_form: true,
            },
            unitAmount: {
                required_display: false,
                required_create: true,
                required_update: false,
                required_administration: false,
                required_form: true,
            },
            method: {
                required_display: true,
                required_create: true,
                required_update: false,
                required_administration: false,
                required_form: true,
            },
            frequency: {
                required_display: true,
                required_create: true,
                required_update: false,
                required_administration: false,
                required_form: true,
            },
            instruction: {
                required_display: true,
                required_create: false,
                required_update: true,
                required_administration: false,
                required_form: true,
            },
            startDate: {
                required_display: false,
                required_create: true,
                required_update: true,
                required_administration: false,
                required_form: true,
            },
            endDate: {
                required_display: false,
                required_create: true,
                required_update: true,
                required_administration: false,
                required_form: true,
            },
            rate: {
                required_display: false,
                required_create: false,
                required_update: false,
                required_administration: false,
                required_form: false,
            },
            unitRate: {
                required_display: false,
                required_create: false,
                required_update: false,
                required_administration: false,
                required_form: false,
            },
            volume: {
                required_display: true,
                required_create: true,
                required_update: false,
                required_administration: true,
                required_form: true,
            },
            unitVolume: {
                required_display: false,
                required_create: true,
                required_update: false,
                required_administration: false,
                required_form: true,
            },
            solution: {
                required_display: true,
                required_create: true,
                required_update: false,
                required_administration: false,
                required_form: true,
            },
            dosageForm: {
                required_display: false,
                required_create: false,
                required_update: false,
                required_administration: false,
                required_form: false,
            },
        },
        icon: 'injection',
    },
    {
        id: 'TABLETS',
        code: 'TABLETS',
        displayName: 'Orale Medikation',
        fieldConfig: {
            amount: {
                required_display: true,
                required_create: true,
                required_update: false,
                required_administration: true,
                required_form: true,
            },
            unitAmount: {
                required_display: false,
                required_create: true,
                required_update: false,
                required_administration: false,
                required_form: true,
            },
            method: {
                required_display: true,
                required_create: true,
                required_update: false,
                required_administration: false,
                required_form: true,
            },
            frequency: {
                required_display: true,
                required_create: true,
                required_update: false,
                required_administration: false,
                required_form: true,
            },
            instruction: {
                required_display: true,
                required_create: false,
                required_update: false,
                required_administration: false,
                required_form: true,
            },
            startDate: {
                required_display: false,
                required_create: false,
                required_update: false,
                required_administration: false,
                required_form: true,
            },
            endDate: {
                required_display: false,
                required_create: false,
                required_update: false,
                required_administration: false,
                required_form: true,
            },
            rate: {
                required_display: false,
                required_create: false,
                required_update: false,
                required_administration: false,
                required_form: false,
            },
            unitRate: {
                required_display: false,
                required_create: false,
                required_update: false,
                required_administration: false,
                required_form: false,
            },
            volume: {
                required_display: false,
                required_create: false,
                required_update: false,
                required_administration: false,
                required_form: false,
            },
            unitVolume: {
                required_display: false,
                required_create: false,
                required_update: false,
                required_administration: false,
                required_form: false,
            },
            solution: {
                required_display: false,
                required_create: false,
                required_update: false,
                required_administration: false,
                required_form: false,
            },
            dosageForm: {
                required_display: false,
                required_create: true,
                required_update: false,
                required_administration: false,
                required_form: true,
            },
        },
        icon: 'medication',
    },
    {
        id: 'MEDICINES',
        code: 'MEDICINES',
        displayName: 'Sonstige Medikamente',
        fieldConfig: {
            amount: {
                required_display: true,
                required_create: true,
                required_update: false,
                required_administration: true,
                required_form: true,
            },
            unitAmount: {
                required_display: false,
                required_create: true,
                required_update: false,
                required_administration: false,
                required_form: true,
            },
            method: {
                required_display: true,
                required_create: true,
                required_update: false,
                required_administration: false,
                required_form: true,
            },
            frequency: {
                required_display: true,
                required_create: true,
                required_update: false,
                required_administration: false,
                required_form: true,
            },
            instruction: {
                required_display: true,
                required_create: false,
                required_update: true,
                required_administration: false,
                required_form: true,
            },
            startDate: {
                required_display: false,
                required_create: false,
                required_update: false,
                required_administration: false,
                required_form: true,
            },
            endDate: {
                required_display: false,
                required_create: true,
                required_update: true,
                required_administration: false,
                required_form: true,
            },
            rate: {
                required_display: false,
                required_create: false,
                required_update: false,
                required_administration: false,
                required_form: false,
            },
            unitRate: {
                required_display: false,
                required_create: false,
                required_update: false,
                required_administration: false,
                required_form: false,
            },
            volume: {
                required_display: false,
                required_create: false,
                required_update: false,
                required_administration: false,
                required_form: false,
            },
            unitVolume: {
                required_display: false,
                required_create: false,
                required_update: false,
                required_administration: false,
                required_form: false,
            },
            solution: {
                required_display: false,
                required_create: false,
                required_update: false,
                required_administration: false,
                required_form: false,
            },
            dosageForm: {
                required_display: true,
                required_create: true,
                required_update: false,
                required_administration: false,
                required_form: false,
            },
        },
        icon: 'medication',
    },
];

export const MOCK_PRESCRIPTION_FREQUENCIES = [
    {
        id: 'continuous',
        code: 'continuous',
        snomedCode: '307439001',
        displayName: 'Continuous',
        timingCode: '',
        timingDisplayName: '',
    },
    {
        id: '4-times-per-1-day',
        code: '4-times-per-1-day',
        snomedCode: '307439001',
        displayName: '4x täglich',
        timingCode: 'QID',
        timingDisplayName: 'Four times a day at institution specified time',
    },
    {
        id: '2-times-per-1-day',
        code: '2-times-per-1-day',
        snomedCode: '229799001',
        displayName: '2x täglich',
        timingCode: 'BID',
        timingDisplayName: 'Two times a day at institution specified time',
    },
    {
        id: 'custom',
        code: customFrequencyCode,
        snomedCode: '307439001',
        displayName: 'Custom',
        timingCode: '',
        timingDisplayName: '',
    },
];

/**
 * Mock prescription frequency times
 */
export const MOCK_PRESCRIPTION_FREQUENCY_TIMES = [
    {
        id: '0e2e5dcd-7924-48f3-9d66-ddefdbe3b061',
        prescriptionFrequencyCode: '2-times-per-1-day',
        hour: 6,
        minute: 0,
        repeatAfterMinutes: 1440,
    },
    {
        id: '79795303-2207-445f-aa4a-a6379ba76f52',
        prescriptionFrequencyCode: '2-times-per-1-day',
        hour: 12,
        minute: 0,
        repeatAfterMinutes: 1440,
    },
    {
        id: '9c232429-bfef-49bd-8305-1044731e84b9',
        prescriptionFrequencyCode: '4-times-per-1-day',
        hour: 6,
        minute: 0,
        repeatAfterMinutes: 1440,
    },
    {
        id: 'c5e99a36-5d46-4b06-81c4-9d2761ca6dab',
        prescriptionFrequencyCode: '4-times-per-1-day',
        hour: 8,
        minute: 0,
        repeatAfterMinutes: 1440,
    },
    {
        id: '48e6b41d-4381-4314-b1e3-682d539b5499',
        prescriptionFrequencyCode: '4-times-per-1-day',
        hour: 15,
        minute: 0,
        repeatAfterMinutes: 1440,
    },
    {
        id: 'c67cab3d-0ae4-40fc-aea6-e89263438859',
        prescriptionFrequencyCode: '4-times-per-1-day',
        hour: 20,
        minute: 0,
        repeatAfterMinutes: 1440,
    },
];

export const MOCK_MEDICATION_ADMINISTRATION_METHODS = [
    {
        id: 'RECTAL',
        code: 'RECTAL',
        displayName: 'Rektal',
        routeCode: '37161004',
        routeDisplayName: 'Rectal use',
    },
];
export const MOCK_MEDICATION_SOLUTIONS = [
    {
        id: '504f68d3-9bf1-44ff-bfe0-c32c33b2b883',
        code: '504f68d3-9bf1-44ff-bfe0-c32c33b2b883',
        displayName: 'normale Kochsalzlösung',
        snomedCode: '313418004',
    },
];
export const MOCK_MEDICATION_DOSAGE_FORMS = [
    {
        id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
        code: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
        displayName: 'string',
    },
];

export const MOCK_STANDARD_MEDICATION = {
    id: '197760b4-2a91-4549-b58f-cbfce1b7ca73',
    medicationCode: '4cbbf206-9c7b-46fa-ab23-e6b8ef8153f5',
    medication: {
        displayName: 'Amrinon',
        categoryCode: 'INJECTIONS',
    },
    frequencyCode: 'continuous',
    administrationMethodCode: 'RECTAL',
    amount: 6,
    unitAmount: 'ml',
    solution: '504f68d3-9bf1-44ff-bfe0-c32c33b2b883',
    volume: 100,
    unitVolume: 'ml',
    rate: 30,
    unitRate: 'ml/h',
};

export const MOCK_MEDICATION_PRESCRIPTION = {
    id: '197760b4-2a91-4549-b58f-cbfce1b7ca73',
    code: '4cbbf206-9c7b-46fa-ab23-e6b8ef8153f5',
    description: 'Amrinon',
    category: 'INJECTIONS',
    frequency: 'continuous',
    method: 'RECTAL',
    amount: 6,
    unitAmount: 'ml',
    solutionCode: '504f68d3-9bf1-44ff-bfe0-c32c33b2b883',
    volume: 100,
    unitVolume: 'ml',
    rate: 30,
    unitRate: 'ml/h',
};

export const MOCK_MEDICATION_UNITS = [
    {
        unit: 'ml',
        categoryCode: MOCK_MEDICATION_CATEGORIES[0].code,
        id: 'c77f415e-40d3-477e-a008-cdfd7c5523cc',
        // ucum_code: 'mL',
    },
    {
        unit: 'ml',
        categoryCode: MOCK_MEDICATION_CATEGORIES[0].code,
        id: '6ef4ab5a-3a5b-4eee-a3be-e087a57d7013',
        // ucum_code: 'mL',
    },
    {
        unit: 'ml/h',
        categoryCode: MOCK_MEDICATION_CATEGORIES[1].code,
        id: '3e8a3e7d-ff06-4f1d-9bff-6e19fc072dff',
        // ucum_code: 'mL/h',
    },
];

export const MOCK_PATIENTS: Patient[] = [
    {
        id: '5718da06-4d51-402b-a8c3-2564d4160449',
        firstName: 'Jonathan',
        lastName: 'Wirtzz',
        prefix: '',
        patientNumber: 'IDC234DKL374',
        gender: ApiModels.Patient.GenderEnum.Male,
        dateOfBirth: new Date('1977-04-21T09:52:21.961Z'),
        deceased: true,
        dateOfDeath: null,
        lastChangedBy: '',
        caseId: 'MGD255LKK345F34',
        parentEncounterId: '',
        parentEncounterStatus: 'Active',
        staysList: [],
    },
    {
        id: '462f444f-b0b0-4227-98f1-f2f670b54738',
        firstName: 'Jonathan',
        lastName: 'Wirtz',
        prefix: '',
        patientNumber: 'IDC234DKL374',
        gender: ApiModels.Patient.GenderEnum.Male,
        dateOfBirth: new Date('1977-04-23T09:52:27.961Z'),
        deceased: true,
        dateOfDeath: null,
        lastChangedBy: '',
        caseId: 'MGD255LKK345FJFJS34',
        parentEncounterId: '',
        parentEncounterStatus: 'Active',
        staysList: [],
    },
    {
        id: '8c42a2a5-3822-4cf4-912a-cfc4cd80e2f7',
        firstName: 'Jonathan',
        lastName: 'Wirtz',
        prefix: '',
        patientNumber: 'SDF34GTE3456CCC3457',
        gender: ApiModels.Patient.GenderEnum.Male,
        dateOfBirth: new Date('1967-04-21T09:52:27.961Z'),
        deceased: true,
        dateOfDeath: null,
        lastChangedBy: '',
        caseId: 'VVDSLLY54FDS43',
        parentEncounterId: '',
        parentEncounterStatus: 'Active',
        staysList: [],
    },
];
